import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function LinkBerechnungsbeispiel() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <span className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.label',
        )}
      </span>
      <a
        href="https://hilfe.e2n.de/bewertung-von-abwesenheiten#dynamische-berechnung"
        target="_blank"
        rel="noreferrer noopener"
        className="flex gap-2 py-2 px-3 items-center text-primary-blue-600 text-sm font-semibold hover:bg-neutrals-200 w-fit rounded-md">
        <FontAwesomeIcon icon={faArrowRight} className="size-5" />
        <span>
          {t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.link',
          )}
        </span>
      </a>
    </div>
  );
}
